export default __webpack_public_path__ + "static/media/ic-calendar.a83a571d.svg";